import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import useHomeFlow from "../../../../hooks/useHomeFlowSimple";
import { STEP_NAME_START } from "../../../../pages/homeInsurancePages/newHomePolicy/data";
import { selectLoginTokenInfo } from "../../../../redux/features/loginRegisterSlice";
import BasicInfo from "./basicInfo/basicInfo";
import DocumentsReadyInfo from "./documentsReadyInfo/documentsReadyInfo";
import "./startPage.css";

const HomeStartPage = ({ onClose }) => {
  const { currentStep, currentSubstepIndex, handleNextSubstep } = useHomeFlow();
  const isOnStartStep = currentStep?.name === STEP_NAME_START;
  const loginTokenInfo = useSelector(selectLoginTokenInfo);
  const isLoggedin = !!loginTokenInfo;

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const w = queryParams.get("w") === "true"; // Website redirect
  const e = queryParams.get("email") || ""; // Email parameter

  // If logged in or redirected from website, skip user info step
  useEffect(() => {
    if (!isOnStartStep) return;
    if (isLoggedin && currentSubstepIndex !== 1) {
      handleNextSubstep();
    }
    if ((w || e) && currentSubstepIndex !== 1) {
      handleNextSubstep();
    }
  }, [isOnStartStep, isLoggedin, currentSubstepIndex, handleNextSubstep, w, e]);

  return (
    <div className="flex flex-col items-center gap-6 bg-white max767:p-5 max767:pt-0">
      {isLoggedin ? (
        currentSubstepIndex === 1 ? (
          <DocumentsReadyInfo
            continueClickHandler={handleNextSubstep}
            hide_back_btn={true}
            show_close_btn={true}
            onClose={onClose}
          />
        ) : (
          <div className="p-4">Loading...</div>
        )
      ) : (
        <>
          {currentSubstepIndex === 0 ? (
            <BasicInfo
              continueClickHandler={handleNextSubstep}
              onClose={onClose}
            />
          ) : currentSubstepIndex === 1 ? (
            <DocumentsReadyInfo
              continueClickHandler={handleNextSubstep}
              hide_back_btn={false}
              show_close_btn={false}
              onClose={onClose}
            />
          ) : (
            <div className="p-4">Loading...</div>
          )}
        </>
      )}
    </div>
  );
};

export default HomeStartPage;
